import { create } from 'zustand'

interface DeviceStoreState {
  selectedDeviceIds: string[] | null
}

interface DeviceStoreActions {
  setSelectedDeviceIds: (ids: string[] | null) => void
  reset: () => void
}

type DeviceStore = DeviceStoreState & DeviceStoreActions

const initialState: DeviceStoreState = {
  selectedDeviceIds: null,
}

export const useDeviceStore = create<DeviceStore>()((set) => ({
  ...initialState,

  setSelectedDeviceIds: (ids) => set({ selectedDeviceIds: ids }),

  reset: () => set(initialState),
}))
